/** Solid white fields with square corners on the app light blue page background (`#BFD3EA`). */
const outlinedOnPageBlue = {
  bgcolor: '#ffffff',
  borderRadius: 0,
  '& fieldset': {
    borderColor: 'rgba(45, 75, 115, 0.3)',
    borderRadius: 0,
  },
  '&:hover fieldset': {
    borderColor: 'rgba(45, 75, 115, 0.5)',
  },
  '&.Mui-focused fieldset': {
    borderColor: '#2D4B73',
  },
} as const;

export const fieldOnPageBlueSx = {
  ...outlinedOnPageBlue,
  '& .MuiOutlinedInput-root': outlinedOnPageBlue,
} as const;

export const selectMenuWhitePaperProps = {
  PaperProps: { sx: { bgcolor: '#ffffff' } },
} as const;
